<template>
    <li
        class="relative group w-full bg-[#102f4e] lg:bg-transparent text-white border-b lg:border-0 border-[#607d8b]"
    >
        <div class="flex items-center">
            <navigation-item
                :item="item"
                type="div"
                class="px-5 lg:px-0 pb-1"
            />
            <button
                ref="dropdownToggle"
                :aria-expanded="active"
                :aria-controls="`dropdown_item_${randomId}`"
                aria-label="Expand dropdown"
                type="button"
                :class="{
                    'flex items-center h-full text-white appearance-none transition-transform duration-150 lg:duration-300 px-4 py-2 lg:py-0 lg:px-0 lg:-ml-1 lg:mr-1 mb-1': true,
                    '-scale-y-100': active,
                    'scale-y-100': !active
                }"
                @click="toggle"
            >
                <fa-icon :icon="['fas', 'angle-down']" fixed-width />
            </button>
        </div>
        <ul
            ref="dropdownItems"
            :id="`dropdown_item_${randomId}`"
            :class="{
                'lg:absolute lg:top-full lg:left-0 origin-top-left bg-[#c50a6e] lg:rounded lg:shadow-lg border-t lg:border-0 border-[#607d8b] lg:overflow-hidden lg:group-hover:block transition-all duration-150': true,
                'block visible pointer-events-auto opacity-100': active,
                'hidden lg:hidden invisible pointer-events-none opacity-0 lg:group-hover:visible lg:group-hover:pointer-events-auto lg:group-hover:opacity-100': !active
            }"
            @keyup.esc="loseFocus"
        >
            <navigation-item
                v-for="(subItem, index) in items"
                :key="index"
                :item="subItem"
                :subItem="true"
                :in-dropdown-menu="true"
                class="lg:first:rounded-t lg:last:rounded-b"
            />
        </ul>
    </li>
</template>
<script>
export default {
	name: 'NavigationDropdown',

    data () {
        return {
            randomId: null,
            active: false
        }
    },

	props: {
		items: {
			type: Array,
			required: true
		},

        item: {
            type: Object,
            required: true
        }
	},

    mounted () {
        this.randomId = window.crypto.getRandomValues(new Uint32Array(1))
    },

    methods: {
        show () {
            this.active = true
        },

        hide () {
            this.active = false
        },

        toggle () {
            this.active = !this.active
            console.info(this.active)
        },

        loseFocus () {
            this.$refs.dropdownToggle.focus()
            this.active = false
        }
    }
}
</script>
